(function () {
    'use strict';
    angular.module('app').controller('RoutePlanningModalController', RoutePlanningModalController);
    RoutePlanningModalController.$inject = [
        'jobs',
        'id',
        '$timeout',
        '$uibModalInstance',
        'FleetService',
        'toastr',
        '$uibModal'
    ];
    function RoutePlanningModalController(
        jobs,
        id,
        $timeout,
        $uibModalInstance,
        FleetService,
        toastr,
        $uibModal
    ) {
        const vm = this;
        let googleMapInstance;
        let markers = [];
        let hoverTimeout;

        vm.onSearchJob = onSearchJob;
        vm.onSelectJob = onSelectJob;
        vm.onSearchDriver = onSearchDriver;
        vm.onSelectDriver = onSelectDriver;
        vm.onDropComplete = onDropComplete;
        vm.saveRun = saveRun;
        vm.onRemoveJob = onRemoveJob;
        vm.onEditDriverAddress = onEditDriverAddress;
        vm.cancel = cancel;
        vm.isDriverAddressLastMileChange = isDriverAddressLastMileChange;

        init();

        function init() {
            if (id) {
                initEditRunData(id);
                return;
            }

            initCreateRunData();
        }

        function initEditRunData(id) {
            FleetService.RoutePlanning.getRunDetails(data => {
                vm.selectedDriver = {
                    id: data.driverId,
                    firstName: data.driverFirstName,
                    lastName: data.driverLastName
                }

                vm.jobs = data.stops.map(job => {
                    return {
                        id: job.id,
                        jobId: job.jobNumber,
                        formattedDestinationAddress: `${job.addressLine1} ${job.addressLine2} ${job.cityOrSuburb} ${job.postcode}`,
                        locationData: {
                            lat: job.latitude,
                            lng: job.longitude
                        }
                    };
                });
            }, error => {
                toastr.error(error.message, 'Error');
            }, id);
        }

        function initCreateRunData() {
            vm.jobs = [];
            for (let i = 0; i < jobs.length; i++) {
                const job = jobs[i];
                const addressData = i == 0 ? job.sourceAddress : job.destinationAddress;

                vm.jobs.push({
                    id: job.id,
                    jobId: job.jobId,
                    formattedDestinationAddress: parseAddress(addressData),
                    locationData: {
                        lat: addressData.location.latitude,
                        lng: addressData.location.longitude
                    }
                });
            }
        }

        function onSearchJob(searchTerm) {
            FleetService.RoutePlanning.getRoutePlanningAvailableJobs(data => {
                if (!vm.jobs) { return; }
                const selectedIds = new Set(vm.jobs.map(item => item.jobId));
                vm.foundJobs = data.content.filter(item => !selectedIds.has(item.jobId));
            }, error => {
                toastr.error(error.message, 'Error');
            }, { consignmentId: searchTerm });
        }

        function onSelectJob(job) {
            const jobData = {
                id: job.id,
                jobId: job.jobId,
                formattedDestinationAddress: parseAddress(job.destinationAddress),
                locationData: {
                    lat: job.destinationAddress.location.latitude,
                    lng: job.destinationAddress.location.longitude
                }
            };

            vm.jobs.splice(vm.jobs.length - 2, 0, jobData);
        }

        function parseAddress(address, isNameIncluded = true) {
            const { firstName, lastName, addressLine1, addressLine2, location } = address;
            const { country, state, name, code } = location;

            if (isNameIncluded) {
                return `${firstName} ${lastName} ${addressLine1} ${addressLine2 || ''} ${name} ${state ? state.name : ''} ${code} ${country.code}`;
            }

            return `${addressLine1} ${addressLine2 || ''} ${name} ${state ? state.name : ''} ${code} ${country.code}`;
        }

        function onDropComplete(dragIndex, dropIndex) {
            const dragData = vm.jobs[dragIndex];
            vm.jobs.splice(dragIndex, 1);
            vm.jobs.splice(dropIndex, 0, dragData);
            initMarkers();
        }

        function onRemoveJob(index) {
            if (vm.jobs.length < 2) {
                vm.jobs = []; // clear all jobs
                markers.forEach(marker => { marker.setMap(null); });
                markers = [];
                return;
            }

            vm.jobs.splice(index, 1);
            markers.forEach((marker, markerIndex) => {
                if (markerIndex === index) { marker.setMap(null); }
            });
            markers.splice(index, 1);
        }

        function onSearchDriver(searchTerm) {
            FleetService.Drivers.getAll(data => {
                vm.drivers = data.content;
            }, error => {
                toastr.error(error.message, 'Error');
            }, { name: searchTerm });
        }

        function onSelectDriver() {
            if (!vm.isDriverAddressLastMile) { return; } 
            removeDriverAddressAsLastMile();
            addDriverAddressAsLastMile();
        }

        function isDriverAddressLastMileChange() {
            const checked = !vm.isDriverAddressLastMile;
            if (checked) {
                addDriverAddressAsLastMile();
                return;
            }

           removeDriverAddressAsLastMile();
        }

        function removeDriverAddressAsLastMile() {
            const lastItemIndex = vm.jobs.length - 1;
            onRemoveJob(lastItemIndex);
        }

        function addDriverAddressAsLastMile() {
            const driverData = {
                driverName: `${vm.selectedDriver.firstName} ${vm.selectedDriver.lastName}`,
                formattedDestinationAddress: parseAddress(vm.selectedDriver, false),
                locationData: {
                    lat: vm.selectedDriver.latitude,
                    lng: vm.selectedDriver.longitude
                }
            };
            vm.jobs.push(driverData);
        }

        function saveRun() {
            if (!vm.selectedDriver) {
                console.log('Please select a driver');
                return;
            }

            const payload = createPayload();
            FleetService.RoutePlanning.saveRun(data => {
                toastr.success('Run successfully saved!', 'Success!');
                $uibModalInstance.close(data);
            }, error => {
                toastr.error(error.message, 'Error');
            }, payload);
        }

        function createPayload() {
            return {
                driverAddress: {
                    addressLine1: vm.selectedDriver.addressLine1,
                    addressLine2: vm.selectedDriver.addressLine2,
                    locationId: vm.selectedDriver.location.id
                },
                driverId: vm.selectedDriver.id,
                jobIds: vm.jobs.filter(job => job.id).map(job => job.id)
            }
        }

        function onEditDriverAddress() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/pages/route-planning/modal/rp-edit-driver-address.modal.html',
                controller: 'RPEditDriverAddressModalController',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body'),
                resolve: {
                    driverData: () => vm.selectedDriver
                }
            }).result.then(data => {
                if (!data) { return; }
                vm.selectedDriver = data;
            });
        }

        function cancel() {
            $uibModalInstance.close();
        }
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/route-planning/modal/RoutePlanningModalController.js